/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useTranslations } from "src/utils/translations"

function SEO({ description, lang, meta, title, image, seoTitle, seoDescription }) {
  const { language } = useTranslations()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description //|| site.siteMetadata.description
  const titleTemplate = title ? `${title} - ${site.siteMetadata.title}` : site.siteMetadata.title

  if (image) { 
    image = typeof image === 'object' ? (image.source_url ? image.source_url : '') : image;
  }
  const metaImage = image
    ? image.includes("http")
      ? image
      : site.siteMetadata.siteUrl + image
    : ""

  return (
    <Helmet
      htmlAttributes={{
        lang: lang || language,
      }}
      title={seoTitle || title || titleTemplate}
      titleTemplate={titleTemplate}
      meta={[
        {
          name: `description`,
          content: seoDescription || metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:site`,
          content: '@ArtReview_',
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: null, // Will use current language from translation system
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
